import React from 'react'
import Navigation from './navigation'
import SocialIcons from './socialIcons'

const Footer = () => (
    <footer>
        <Navigation />
        <SocialIcons />
    </footer>
)

export default Footer;